import type { FC } from 'react';

export interface SvgProps {
  className: string;
}

export const LikeSvg: FC<SvgProps> = (props) => {
  const { ...restProps } = props;
  return (
    <svg
      {...restProps}
      width='35'
      height='35'
      viewBox='0 0 35 35'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M9.87264 2.5C4.42453 2.5 1 7.54617 1 11.6156C1 20.5684 10.6509 27.2911 17.5 32.5C24.3491 27.2911 34 20.5684 34 11.6156C34 7.54617 30.5755 2.5 25.1274 2.5C22.0141 2.5 19.3679 5.10451 17.5 7.54617C15.4764 5.10451 12.9858 2.5 9.87264 2.5Z'
        stroke='black'
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export const BonusSvg: FC<SvgProps> = (props) => {
  const { ...restProps } = props;
  return (
    <svg
      {...restProps}
      width='35'
      height='35'
      viewBox='0 0 35 35'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M12.8042 21.7079C12.4597 19.7588 12.2127 14.8443 13.2212 12.9072C13.3723 12.6171 13.5488 12.35 13.7433 12.1041C15.6013 9.75581 18.5379 9.4363 21.5058 9.03873M34 17.4961C34 26.6088 26.6127 33.9961 17.5 33.9961C8.3873 33.9961 1 26.6088 1 17.4961C1 8.38339 8.3873 0.996094 17.5 0.996094C26.6127 0.996094 34 8.38339 34 17.4961ZM22.5845 21.4459C22.1505 24.1646 19.5948 26.0167 16.8761 25.5827C14.1574 25.1487 12.3053 22.593 12.7393 19.8743C13.1733 17.1556 15.729 15.3035 18.4477 15.7375C21.1664 16.1715 23.0185 18.7272 22.5845 21.4459Z'
        stroke='black'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};
